import { Popover } from '@headlessui/react';
import React from 'react';
import IconCaret from '../../../ui/icons/IconCaret';
import classNames from 'classnames';
import IconCheckmarkCircle from '../../../ui/icons/IconCheckmarkCircle';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

const SearchFilterPanel = ( props ) => {
	const { results } = useInstantSearch();
	const { label, children, position = 'left', hasRefinement = false, isDisabled = false } = props;

	const positionClass = classNames( {
		'tw-left-0': position === 'left',
		'-tw-right-0': position === 'right',
	} );

	return (
		<Popover className="tw-relative tw-flex tw-items-center" >
			{( { open } ) => (
				<>
					<Popover.Button disabled={isDisabled} className={`tw-group disabled:tw-text-slate hover:tw-text-slate tw-bg-transparent tw-min-w-[70px] tw-text-sm lg:tw-text-base tw-flex tw-items-center tw-font-normal tw-whitespace-nowrap`}>
						{label}
						{hasRefinement && (
							<span className={`tw-ml-2 tw-bg-aloe tw-p-1 tw-rounded-full`}><IconCheckmarkCircle /></span>
						)}
						<span className={`${ open ? 'tw-rotate-180' : '' } tw-transition-all tw-ml-2`}>
							<IconCaret fill={isDisabled ? 'slate' : 'charcoal'} />
						</span>
					</Popover.Button>

					<Popover.Panel unmount={false} className={`${ positionClass } tw-animate-fade-in tw-absolute tw-z-10 tw-top-8 tw-bg-white tw-shadow tw-p-6 tw-min-w-[400px]`}>
						<div>
							{children}
						</div>
					</Popover.Panel>
				</>
			)}
		</Popover>
	);
};

export default SearchFilterPanel;
